/* eslint-disable react/display-name */
import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';

import { ListItem, ListItemIcon, ListItemText } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  itemLeaf: {
    display: 'flex',
    paddingLeft: 16,
  },
  icon: {
    color: theme.palette.icon,
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1),
  },
}));

const SideBarListItem = (props) => {
  const { title, style, onClick, icon: Icon, className, selected } = props;

  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <ListItem
      style={style}
      selected={selected}
      button
      onClick={onClick}
      className={clsx(classes.itemLeaf, className)}
      disableGutters
    >
      {Icon && (
        <ListItemIcon>
          <Icon className={classes.icon} />
        </ListItemIcon>
      )}
      <ListItemText primary={t(title)} />
    </ListItem>
  );
};

SideBarListItem.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.any,
  selected: PropTypes.bool,
  title: PropTypes.string.isRequired,
  style: PropTypes.object,
};

SideBarListItem.defaultProps = {
  selected: false,
  className: undefined,
  icon: undefined,
  style: undefined,
};

export default SideBarListItem;
